// import { firestore } from '../../config/firebaseConfig'

export default function EmptyItem() {

    // const handleUpdate = async() =>{
    //     const thePo = await firestore.collection('purchase_orders').where('PoRef', '==', 351).get();

    //     thePo.docs.forEach(doc =>{
    //         const item = doc.data();

    //         let Purchases = item.Purchases;
    //         let correctPurchase = [];

    //         Purchases.forEach((purchase) =>{
    //             const exist = correctPurchase.find(it => it.Barcode === purchase.Barcode && 
    //                                                 it.Quantity === purchase.Quantity && 
    //                                                 it.Price === purchase.Price)
    //             if(!exist){
    //                 correctPurchase.push(purchase);
    //             }
    //         })


    //         console.log(correctPurchase)
    //         firestore.collection('purchase_orders').doc(doc.id).set({Purchases: correctPurchase}, {merge : true}).then(()=>{
    //             console.log('Update Done');
    //         });
    //     })
    // }
    return (
        <div>
            {/* <button onClick={handleUpdate}> Run </button> */}
        </div>
    )
}
